module.exports = __webpack_public_path__ + "img/result-restore-btn.f843ca2f.png";